import type { ButtonWithSurfaceMaterial } from '@seddi/scene';
import type { LoadingManager, WebGLRenderer } from '@seddi/three';
import log from 'loglevel';

import { load } from './buttonLoader';
import type { ButtonGfx } from './buttonTypes';
import { ResourceManager } from './resourceManager';

export class ButtonsContext extends ResourceManager<ButtonGfx> {
  readonly manager: LoadingManager;
  readonly renderer: WebGLRenderer;

  constructor(manager: LoadingManager, renderer: WebGLRenderer) {
    super();
    this.manager = manager;
    this.renderer = renderer;
  }

  async loadAsync(desc: ButtonWithSurfaceMaterial): Promise<ButtonGfx | undefined> {
    if (this.find(desc.id)) {
      log.warn(`ButtonsContext.loadAsync: ${desc.id} is not new.`);
      return undefined;
    }

    const item = this.create(desc.id);
    item.status = 'loading';

    const value = await load(desc, this.manager, this.renderer);
    item.status = 'ready';
    item.value = value;

    if (this.onLoad) {
      this.onLoad(desc.id, 'Button');
    }

    return value;
  }
}
